"use strict";

import Cookies from "js-cookie";

export default class AnnouncementBanner {
  constructor($selector, homepage = false, selfInit = true) {
    this.$selector = $selector;
    this.offset = this.$selector.offset().top;
    this.height = this.$selector.find(".container").outerHeight();
    this.cookieData = {
      'globalClosed': false,
      'internalPages': []
    }

    if (selfInit) this.init();
  }

  init() {
    if(Cookies.get('imda_annoucements')) {
      this.cookieData = JSON.parse(Cookies.get('imda_annoucements'));
    }

    if(!this.cookieData.globalClosed) {
      $('.announcement-banner-item:not(.announcement-banner-item--gray)', this.$selector).slideDown(300);
    }

    if(this.cookieData.internalPages.indexOf(window.location.pathname) < 0) {
      $('.announcement-banner-item--gray', this.$selector).slideDown(300);
    }

    $("button", this.$selector).map((i,ele) => {
      $(ele).on('click', (e) => {
        e.preventDefault();
        
        $(ele).closest('.announcement-banner-item').slideUp(300);

        if(!$(ele).closest('.announcement-banner-item').hasClass('announcement-banner-item--gray')) {
          this.cookieData.globalClosed = true;
          Cookies.set('imda_annoucements', JSON.stringify(this.cookieData));
        }
        else {
          this.cookieData.internalPages.push(window.location.pathname);
          Cookies.set('imda_annoucements', JSON.stringify(this.cookieData));
        }
      });
    });
  }

  setUI() {
    this.height = this.$selector.outerHeight();
    $(".home-banner__media").css("min-height", `${667 + this.height}px`);
    $(".home-banner__text h1").css("padding-top", `${35 + this.height}px`);
  }
}
